module.exports = __webpack_public_path__ + "img/80ne.0a50dfad.svg";